var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      !_vm.accessibility
        ? _c(
            "pga-bottom-navigation",
            [
              _c(
                "pga-authorized-content",
                { attrs: { permission: "EditCertification" } },
                [_c("pga-save-button", { on: { click: _vm.Edit } })],
                1
              ),
              _c("pga-cancel-button", { on: { click: _vm.undo } }),
            ],
            1
          )
        : _vm._e(),
      _c(
        "pga-skeleton-loader",
        { attrs: { "is-loaded": _vm.CertificationEdit.Command } },
        [
          !_vm.accessibility
            ? _c("pga-certification-edit", {
                model: {
                  value: _vm.CertificationEdit.Command,
                  callback: function ($$v) {
                    _vm.$set(_vm.CertificationEdit, "Command", $$v)
                  },
                  expression: "CertificationEdit.Command",
                },
              })
            : _c("pga-certification-edit-accessibility", {
                on: { "save-accessibility": _vm.Edit },
                model: {
                  value: _vm.CertificationEdit.Command,
                  callback: function ($$v) {
                    _vm.$set(_vm.CertificationEdit, "Command", $$v)
                  },
                  expression: "CertificationEdit.Command",
                },
              }),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }